import React, { useEffect, useRef, useState } from "react";
import "./History.css";
import historyimg from "../assets/loading_history.svg";
import { logEvent } from "firebase/analytics";
import { analytics } from "../components/firebase";
import { config } from "../config";
import LeftPanel from "../components/leftPanel";
import { useNavigate } from "react-router-dom";
import GoogleButton from "../components/GoogleAuth";
import { useHistoryData } from "../components/HistoryContext";
import { toast, ToastContainer } from "react-toastify";

const History = ({ showHeader = true }) => {
  const {
    items,
    setItems,
    fetched,
    setFetched,
    initialLoading,
    setInitialLoading,
  } = useHistoryData();

  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const googleAuthRef = useRef(null);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  useEffect(() => {
    logEvent(analytics, "component_view", { component_name: "History" });
  }, []);

  useEffect(() => {
    const waitForRefAndFetch = async () => {
      let attempts = 0;
      while (!googleAuthRef.current && attempts < 10) {
        await new Promise((res) => setTimeout(res, 100));
        attempts++;
      }

      if (!fetched) {
        await fetchHistory();
        
      } else {
        setInitialLoading(false);
      }
    };
    waitForRefAndFetch();
  }, [fetched, setFetched, setInitialLoading]);

  const fetchHistory = async () => {
    try {
      const response = await fetch(`${config.baseURL}/get_history.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();

      if (data.success) {
        if (data.history && data.history.length > 0) {
          setItems(data.history);
        } else {
          setError("No History Yet !");
        }
        setFetched(true);
      } else {
        const msg = data.message || "";
        if (msg.includes("expired token") || msg.includes("Authorization token not found.")) {
          setShowLoginPopup(true);          
          return;
        }
        setError("Failed to get history.");
        setItems([]);
      }
    } catch (err) {
      setError("An error occurred while fetching history.");
    } finally {
      setInitialLoading(false);
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const navigateToResult = (item) => {
    if (!item) return;
    if (item.topic_type === "chat") {
      navigate("/ai-assistant", { state: { history_Id: item.history_Id } });
      logEvent(analytics, "chat_history_clicked", { history_Id: item.history_Id });
    } else if (item.topic_type === "document" && item.ai_result) {
      navigate("/history-view", {
        state: { result: item.ai_result, history_id: item.history_Id },
      });
      logEvent(analytics, "document_history_clicked", {
        document_id: item.id,
        document_preview: item.ai_result.substring(0, 50),
      });
    }
  };

  const handleLoginSuccess = () => {
    toast.success("Login successful! Refreshing your data...", {
      position: "top-right",
      autoClose: 2000,
    });
    setTimeout(() => window.location.reload(), 2000);
  };

  const handleLoginFailure = () => {
    toast.error("Log in failed! Please try again later");
  };

  if (initialLoading) {
    return (
      <div>
        <LeftPanel />
        {showHeader && (
          <div className="leftpanel_history">
            <div className="backbtntext">
              <button className="back-button" onClick={handleBackClick}>
                <img src={config.Backbutton} alt="Back" />
              </button>
              <div>Your History</div>
            </div>
          </div>
        )}
        <div className="seperation-div">
          <div className="history_null">
            <img src={historyimg} alt="History" />
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <LeftPanel />
        <div className="seperation-div">
          {showHeader && (
            <div className="leftpanel_history">
              <div className="backbtntext">
                <button className="back-button" onClick={handleBackClick}>
                  <img src={config.Backbutton} alt="Back" />
                </button>
                <div>Your History</div>
              </div>
            </div>
          )}
          <div className="history_null">
            <img src={historyimg} alt="History" />
            {error}
              <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: "15px",
              padding: "10px 20px",
              fontSize: "14px",
              backgroundColor: "#ee5b3e",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
          </div>
        

        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="leftpanel_history">
        <LeftPanel />
      </div>
      <div className={showHeader ? "seperation-div" : "seperation-div no-padding"}>
        {showHeader && (
          <div className="leftpanel_history">
            <div className="backbtntext">
              <button className="back-button" onClick={handleBackClick}>
                <img src={config.Backbutton} alt="Back" />
              </button>
              <div>Your History</div>
            </div>
          </div>
        )}
        <div className="history_box">
          {items
            .slice()
            .reverse()
            .map((item, index) => {
              const words = item.ai_result.split(" ");
              const wordLimit = words.length > 10 ? 6 : 2;
              const titleIndex = words.slice(0, 2).indexOf("Title:");
              const startIndex = titleIndex !== -1 ? titleIndex + 1 : 0;
              const firstWords = words.slice(startIndex, startIndex + wordLimit).join(" ") + " ...";
              return (
                <div
                  className="repeating-group"
                  key={index}
                  onClick={() => navigateToResult(item)}
                >
                  <span className="history_text">{firstWords}</span>
                  <img src={config.rightArrow} alt="open icon" />
                </div>
              );
            })}
        </div>
        <ToastContainer />
      </div>

      {showLoginPopup && (
        <div className="history-login-popup-overlay">
          <div className="history-login-popup">
            <p>Please log in to view your history</p>
            <div className="history-login-popup-buttons">
              <GoogleButton
                id="loginPopup"
                ref={googleAuthRef}
                onLoginSuccess={() => {
                  setShowLoginPopup(false);
                  handleLoginSuccess();
                }}
                onLoginFailure={handleLoginFailure}
              />
              <button onClick={handleBackClick} id="loginPopup">
                Back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default History;
